import React from 'react'
import Image from 'next/image'
import { imageLoaderForStaticImages } from '../context/utils'

const ColoredDivider = () => {
  return (
    <Image
      loader={imageLoaderForStaticImages}
      alt=''
      src={'/common/gradient_line.svg'}
      layout='fill'
      objectFit='cover'
    />
  )
}

export default ColoredDivider
